module.exports = __webpack_public_path__ + "img/coca-cola.a105de62.png";